import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { fetch_all_patients } from "../../endpoints/API";

export const fetchFamilyMember = async (setCustomers, baseUrl, prodTestUrl) => {
  try {
    const response = await fetch_all_patients();
    if (response.statusText=="OK") {
      const data = response?.data;
      setCustomers(data);
    } else {
      message.error("Failed to fetch patients.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching patients.");
  }
};
